export default __webpack_public_path__ + "static/bear-0-c30f4c9b0dd400f5d12c95e8c24d2de3.png";